// Default pad roles for a new kit (SPEC F4). Derived from the groove's
// fallback lane map, so Groove finds the same pads (DECISIONS 2026-10-06).
import type { PercKind, Role } from './types';
import { DEFAULT_LANE_PAD, LANE_ORDER, LANE_ROLE } from './pattern';
import { PAD_COUNT } from '../db/repos/kits';

/** Pads the groove has no lane for: a second kick, a second snare (his rim pad), and a tom and a perc (Elias's own rig). */
const EXTRA_PAD_ROLES: Record<number, Role> = { 4: 'kick', 6: 'snare', 9: 'perc', 10: 'perc' };

/** Role per pad index, A01 = 0. A12 to A15 (ride, crash, FX, vox stab on Elias's rig) have no role: the app has no such roles. */
export const DEFAULT_PAD_ROLES: (Role | undefined)[] = (() => {
  const roles: (Role | undefined)[] = Array.from({ length: PAD_COUNT }, () => undefined);
  for (const lane of LANE_ORDER) roles[DEFAULT_LANE_PAD[lane]] = LANE_ROLE[lane];
  for (const [i, role] of Object.entries(EXTRA_PAD_ROLES)) roles[Number(i)] = role;
  return roles;
})();

/** v0.5.1 (SPEC F4): the kind each new kit's perc pads prefer. A08 shaker, A09 cowbell, A10 tambourine; A11 takes any perc. */
export const DEFAULT_PAD_KINDS: Record<number, PercKind> = { 7: 'shaker', 8: 'cowbell', 9: 'tambourine' };

/** The pad where Suggest kit puts a rim when your library has one (A07, a snare pad: Elias's rim pad, SPEC F4 v0.5.1). */
export const RIM_PAD = 6;

/** Pad ID for an index: 0 is "A01". */
export const padId = (index: number): string => `A${String(index + 1).padStart(2, '0')}`;
